import BaseModel from '../core/BaseModel'
export default class RoleAccessModel extends BaseModel {
    constructor() {
        super({ 
                name: "role_access",
                tableName: 'core_role_access',
                display_key: 'name'
            },
            {
            id: { 
                name: 'id', 
                type: "String", 
                label: 'ID', 
                primaryKey: true,
                display: false
            },
            fied_detail: {
                refs: ' name code type status ',
                display: false
            },
        },)
    }

}